// ============================================================
// BRANDIFY CONTENT CONFIG — edit this ONE file to update the
// brand details, swap placeholder videos/images with your own
// reels & shorts, change links, pricing, or portfolio items.
// ============================================================

export const BRAND = {
  name: "Brandify",
  tagline: "We Turn Streets Into Your Brand's Biggest Stage.",
  subheading: "Real People. Real Reactions. Real Content. Real Results.",
  email: "hello@brandify.social",
  phone: "+91 72591 56106",
  whatsapp: "+91 72591 56106",
  whatsappLink:
    "https://wa.me/917259156106?text=Hi%20Brandify%20Team!%20I%20want%20to%20book%20a%20free%20strategy%20call%20for%20our%20brand.",
  address: "Bengaluru, Karnataka, India",
  socials: {
    instagram: "https://instagram.com",
    youtube: "https://youtube.com",
    facebook: "https://facebook.com",
    linkedin: "https://linkedin.com",
  },
};

// ---------- VERIFIED CINEMATIC STOCK MEDIA (swap anytime) ----------
export const MEDIA = {
  heroVideo:
    "https://videos.pexels.com/video-files/2022395/2022395-hd_1920_1080_30fps.mp4",
  heroPoster:
    "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1600&q=80",
  ctaVideo:
    "https://videos.pexels.com/video-files/3163534/3163534-uhd_3840_2160_30fps.mp4",
  videos: {
    streetNight:
      "https://videos.pexels.com/video-files/2099536/2099536-hd_1920_1080_30fps.mp4",
    rooftopDancer:
      "https://videos.pexels.com/video-files/2795750/2795750-hd_1920_1080_25fps.mp4",
    streetWalk:
      "https://videos.pexels.com/video-files/854100/854100-hd_1920_1080_25fps.mp4",
    droneCity:
      "https://videos.pexels.com/video-files/2818546/2818546-uhd_3840_2160_24fps.mp4",
    editingSuite:
      "https://videos.pexels.com/video-files/1536315/1536315-hd_1920_1080_30fps.mp4",
    crowdWalk:
      "https://videos.pexels.com/video-files/855564/855564-hd_1920_1080_24fps.mp4",
    concertCrowd:
      "https://videos.pexels.com/video-files/2022395/2022395-hd_1920_1080_30fps.mp4",
    strategyMeet:
      "https://videos.pexels.com/video-files/3255275/3255275-uhd_3840_2160_25fps.mp4",
  },
  images: {
    concertConfetti:
      "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?auto=format&fit=crop&w=1200&q=80",
    crowdHands:
      "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&w=1200&q=80",
    stageLights:
      "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1200&q=80",
    eventCrowd:
      "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&w=1200&q=80",
    audience:
      "https://images.unsplash.com/photo-1531058020387-3be344556be6?auto=format&fit=crop&w=1200&q=80",
    neonEvent:
      "https://images.unsplash.com/photo-1505373877841-8d25f7d46678?auto=format&fit=crop&w=1200&q=80",
    cityNight:
      "https://images.unsplash.com/photo-1519501025264-65ba15a82390?auto=format&fit=crop&w=1200&q=80",
    cityStreet:
      "https://images.unsplash.com/photo-1449824913935-59a10b8d2000?auto=format&fit=crop&w=1200&q=80",
    skyline:
      "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=1200&q=80",
    indianMarket:
      "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&w=1200&q=80",
    retailStore:
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80",
    shopping:
      "https://images.unsplash.com/photo-1483985988355-763728e1935b?auto=format&fit=crop&w=1200&q=80",
    campus:
      "https://images.unsplash.com/photo-1523580494863-6f3031224c94?auto=format&fit=crop&w=1200&q=80",
    conference:
      "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=1200&q=80",
    creatorCamera:
      "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80",
    filmProduction:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1200&q=80",
    podcastMic:
      "https://images.unsplash.com/photo-1478737270239-2f02b77fc618?auto=format&fit=crop&w=1200&q=80",
    phoneSocial:
      "https://images.unsplash.com/photo-1611926653458-09294b3142bf?auto=format&fit=crop&w=1200&q=80",
    productShoe:
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=1200&q=80",
    productHeadphones:
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?auto=format&fit=crop&w=1200&q=80",
    friendsCelebration:
      "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?auto=format&fit=crop&w=1200&q=80",
  },
};

// ---------- SOCIAL PROOF MARQUEE ----------
export const SOCIAL_PROOF = [
  "Instagram",
  "YouTube",
  "Facebook",
  "LinkedIn",
  "50M+ Organic Views",
  "Bengaluru Street Kingpins",
  "98% Campaign Recall",
];

// ---------- MANIFESTO CHAPTERS (About) ----------
export const MANIFESTO = [
  {
    number: "01",
    title: "THE STREET ENGINE",
    description:
      "We bypass boring digital banners and take your brand straight onto high-footfall streets, malls, tech parks and campuses across Bengaluru — where real people actually live, walk and play.",
  },
  {
    number: "02",
    title: "UNFILTERED PUBLIC ENERGY",
    description:
      "Street games, blindfold challenges, product sampling and instant giveaways engineered to spark genuine screams, laughter and reactions — the raw emotion algorithms can't fake.",
  },
  {
    number: "03",
    title: "VIRAL CONTENT ECOSYSTEM",
    description:
      "Every activation is captured by cinema cameras, drones and creator rigs, then edited into high-octane Reels and Shorts that turn one street moment into weeks of feed dominance.",
  },
];

// ---------- 13 SERVICES ----------
export const SERVICES = [
  {
    icon: "Megaphone",
    title: "Brand Activation",
    description: "Creating memorable brand experiences that connect with audiences.",
    bullets: ["On-ground brand activations", "Interactive brand experiences", "Product & campaign promotions"],
  },
  {
    icon: "Route",
    title: "Street Marketing",
    description: "Taking brands directly to the streets to create attention and engagement.",
    bullets: ["Street promotions & outreach", "Mobile branding & promotional teams", "Creative guerrilla marketing"],
  },
  {
    icon: "Package",
    title: "Product Sampling",
    description: "Putting products directly into consumers' hands to encourage trial and discovery.",
    bullets: ["Product sampling campaigns", "Consumer trial activities", "High-footfall sampling"],
  },
  {
    icon: "Gamepad2",
    title: "Public Games & Challenges",
    description: "Fun and interactive experiences that turn audiences into active participants.",
    bullets: ["Street games & contests", "Brand-led challenges", "Prizes & instant rewards"],
  },
  {
    icon: "Gift",
    title: "Giveaways",
    description: "Exciting rewards that attract attention and encourage audience participation.",
    bullets: ["Branded giveaways & merchandise", "Contest-based rewards", "Instant prizes & lucky draws"],
  },
  {
    icon: "Store",
    title: "Mall Activations",
    description: "Engaging shoppers through interactive brand experiences in high-footfall locations.",
    bullets: ["Mall kiosks & promotional booths", "Games, contests & experiences", "Product launches & demonstrations"],
  },
  {
    icon: "GraduationCap",
    title: "Campus Activations",
    description: "Connecting brands with young audiences through engaging college experiences.",
    bullets: ["College events & promotions", "Student games & competitions", "Campus ambassador programs"],
  },
  {
    icon: "Briefcase",
    title: "Corporate Events",
    description: "Professional experiences designed to engage employees, clients and business partners.",
    bullets: ["Conferences & corporate events", "Team engagement activities", "Brand launches & celebrations"],
  },
  {
    icon: "Users",
    title: "Influencer Collaborations",
    description: "Connecting brands with creators to reach relevant audiences authentically.",
    bullets: ["Influencer campaigns & partnerships", "Product reviews & integrations", "Creator-led brand storytelling"],
  },
  {
    icon: "Instagram",
    title: "Instagram Reels",
    description: "Short-form videos designed to capture attention and drive social engagement.",
    bullets: ["Creative branded Reels", "Product & service promotions", "Trending content & storytelling"],
  },
  {
    icon: "Youtube",
    title: "YouTube Shorts",
    description: "Fast and engaging videos that help brands reach audiences at scale.",
    bullets: ["Branded Shorts & promotions", "Product-focused video content", "Viral concepts & trends"],
  },
  {
    icon: "Flame",
    title: "Viral Content Creation",
    description: "Creative and shareable content designed to capture attention and spark conversations.",
    bullets: ["Viral video concepts", "Trending & relatable content", "Social-first storytelling & campaigns"],
  },
];

// ---------- PRICING (INR) ----------
export const PRICING = [
  {
    name: "Starter",
    price: "₹9,999",
    tagline: "Perfect for small businesses looking to create quick local awareness and engagement.",
    features: [
      "1 Location",
      "Product Giveaway",
      "Public Interviews & Consumer Engagement",
      "2 Edited Reels",
      "On-ground promotional team",
      "Basic campaign coordination",
    ],
  },
  {
    name: "Growth",
    price: "₹29,999",
    tagline: "Perfect for startups and local brands looking to combine on-ground activation with social media content.",
    features: [
      "Everything in Starter",
      "Street Activation & Public Reactions",
      "Product Sampling & Giveaway",
      "5 Professionally Edited Photos",
      "4 Reels featuring Single or Multiple Consumers (Total Reels – 6)",
      "Campaign Report & Consumer Data",
      "On-ground campaign coordination",
    ],
  },
  {
    name: "Medium",
    price: "₹79,999",
    popular: true,
    tagline: "The complete activation-to-viral-content engine for ambitious brands.",
    features: [
      "Everything in Growth",
      "Multiple Locations",
      "Professional Host",
      "10 Professionally Edited Photos",
      "12 Reels featuring Single or Multiple Consumers (Total Reels – 18)",
      "Social Media Strategy",
    ],
  },
  {
    name: "Premium",
    price: "₹1,99,999",
    pricePrefix: "Starting from",
    tagline: "Full-scale brand takeovers with cinematic production and influencer firepower.",
    features: [
      "Everything in Medium",
      "Full-Day Activation",
      "Dedicated Campaign Manager",
      "Influencer Collaboration",
      "Multi-Camera Production",
      "Brand Film",
      "Multiple Professionally Edited Photos",
      "20 Reels featuring Single or Multiple Consumers (Total Reels – 38)",
      "1 Premium YouTube Long-Form Video (6–10 Minutes)",
      "Monthly Content Strategy",
      "End-to-End Campaign Management",
    ],
  },
];

// ---------- PORTFOLIO (hover = live video preview) ----------
export const PORTFOLIO = [
  {
    title: "STREET FUN GAMES",
    category: "Giveaways",
    location: "COMMERCIAL STREET, BANGALORE",
    metrics: "2.4M Views",
    image: "/assets/street-fun-games-poster.jpg",
    video: "/assets/street-fun-games.mp4",
    autoplay: true,
    link: "", // paste your reel/short URL here later
  },
  {
    title: "CRICKET CHALLENGE",
    category: "College Campus Activation",
    location: "BMS College Bangalore",
    metrics: "4.1M Views",
    image: "/assets/cricket-challenge-bms-poster.jpg",
    video: "/assets/cricket-challenge-bms.mp4",
    autoplay: true,
    link: "",
  },
  {
    title: "ROYAL ENFIELD CONTINENTAL GT 650",
    category: "Product Launches",
    location: "Nagarbhavi Bangalore",
    metrics: "1.8M Views",
    image: "/assets/royal-enfield-gt650-poster.jpg",
    video: "/assets/royal-enfield-gt650.mp4",
    autoplay: true,
    link: "",
  },
  {
    title: "Street Voxpop: Bengaluru Reacts",
    category: "Street Interviews",
    location: "Koramangala 80ft Road",
    metrics: "3.5M Views",
    image: "/assets/street-voxpop-poster.jpg",
    video: "/assets/street-voxpop.mp4",
    autoplay: true,
    link: "",
  },
  {
    title: "THE RAMESHWARAM CAFE",
    category: "Brand Promotion",
    location: "Bommasandra",
    metrics: "1.2M Views",
    image: "/assets/rameshwaram-cafe-poster.jpg",
    video: "/assets/rameshwaram-cafe.mp4",
    autoplay: true,
    link: "",
  },
  {
    title: "DECATHLON INDIA",
    category: "Brand Promotions",
    location: "Brigade Road Bangalore",
    metrics: "5.8M Views",
    image: "/assets/decathlon-india-poster.jpg",
    video: "/assets/decathlon-india.mp4",
    autoplay: true,
    link: "",
  },
];

// ---------- SOCIAL SHOWCASE (clickable placeholders — swap link + video) ----------
export const SOCIAL_SHOWCASE = [
  {
    platform: "Instagram Reels",
    icon: "Instagram",
    handle: "@brandify.live",
    caption: "When Church Street turns into a live gaming arena",
    views: 1400000,
    likes: 142000,
    comments: 1840,
    video: "https://videos.pexels.com/video-files/2795750/2795750-hd_1920_1080_25fps.mp4",
    poster: "https://images.unsplash.com/photo-1533174072545-7a4b6ad7a6c3?auto=format&fit=crop&w=800&q=80",
    link: "https://instagram.com", // replace with your reel URL
  },
  {
    platform: "YouTube Shorts",
    icon: "Youtube",
    handle: "@brandify.shorts",
    caption: "Can Bengaluru guess this prize in 5 seconds?",
    views: 2800000,
    likes: 210000,
    comments: 3100,
    video: "https://videos.pexels.com/video-files/8113091/8113091-hd_1080_1920_30fps.mp4",
    poster: "/assets/shorts-dance-poster.jpg",
    link: "https://youtube.com", // replace with your short URL
  },
  {
    platform: "Facebook Videos",
    icon: "Facebook",
    handle: "Brandify India",
    caption: "Pet Show India",
    views: 890000,
    likes: 45000,
    comments: 620,
    video: "/assets/pet-show-india.mp4",
    poster: "/assets/pet-show-india-poster.jpg",
    link: "https://facebook.com", // replace with your video URL
  },
  {
    platform: "LinkedIn Posts",
    icon: "Linkedin",
    handle: "Brandify Experiential",
    caption: "Why street activations drive 4x higher brand recall",
    views: 340000,
    likes: 18500,
    comments: 890,
    video: "https://videos.pexels.com/video-files/3255275/3255275-uhd_3840_2160_25fps.mp4",
    poster: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?auto=format&fit=crop&w=800&q=80",
    link: "https://linkedin.com", // replace with your post URL
  },
];

// ---------- EDITORIAL MARQUEE ----------
export const EDITORIAL_MARQUEE = [
  "Street Activations",
  "Product Sampling",
  "Public Games",
  "Giveaways",
  "Mall Takeovers",
  "Campus Tours",
  "Influencer Collabs",
  "Viral Reels",
];

export const BUDGET_OPTIONS = ["Under ₹10,000", "₹10,000 – ₹30,000", "₹30,000 – ₹80,000", "₹80,000 – ₹2,00,000", "₹2,00,000+"];
